import {useEffect, useState} from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import usePermisos from '../../../hooks/usePermisos';
import axios from '../../../axios';
import Squares2X2Icon from '@heroicons/react/24/outline/Squares2X2Icon';
import { useNavigate } from 'react-router-dom';


const PERMISOS_REQUERIDOS = [
    'products_create'
];

const New = () => {
    const navigate = useNavigate();
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
    const  [grupo, setGrupo] = useState({name:"", description:""});
    const [validate,setValidate] = useState({name:true});

    useEffect(() => {
        console.log("permisos", permisos);
        if(!loadingPermisos && !tienePermiso) {
            return <div className="p-5 text-center">No tienes permiso para crear una nueva categoría web.</div>
        }
    }, [permisos]);

    const _saveGrupo = (e) => {
        e.preventDefault();
        // Validar campos
        console.log("Guardando grupo", grupo);
        if(grupo.name.trim() === "") {
            setValidate({...validate, name:false});
            return;
        }
        axios.post('/api/product-groups', grupo)
        .then(res => {
            alert("Grupo creado exitosamente");
            navigate('/admin/categoriasweb');
        })
        .catch(err => {
            console.error("Error al crear grupo", err);
            // Mostrar mensaje de error
            if(err.response && err.response.data && err.response.data.message) {
                alert("Error: " + err.response.data.message);
            }   
        });
    }

    return (
         <>
            <div className='container-admin-menu'> <Breadcrumb /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1'>
                    <h5 className="p-5 text-xl font-bold flex items-center justify-start"> <Squares2X2Icon className="inline-block h-6 w-6 mr-2" /> Nueva Categoria Web</h5>
                    <form className='grid grid-cols-12 gap-4 px-5 pb-5' onSubmit={(e)=>_saveGrupo(e)}>
                        {/* Nombre */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="name" className="text-sm font-medium text-gray-600">Nombre de la Categoria*</label>
                                <input
                                    id="name"
                                    type="text"
                                    className="dento-input"
                                    value={grupo.name}
                                    onChange={(e) => setGrupo({ ...grupo, name: e.target.value })}
                                />
                                {!validate.name && (
                                    <span className="text-sm text-red-500">El nombre de la categoría es obligatoria.</span>
                                )}
                            </div>
                        </div>
                        {/* Descripción */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="description" className="text-sm font-medium text-gray-600">Descripción</label>
                                <textarea
                                    id="description"
                                    className="dento-input min-h-26"
                                    value={grupo.description}
                                    onChange={(e) => setGrupo({ ...grupo, description: e.target.value })}
                                />
                            </div>
                        </div>
                        {/* Botón guardar  si tiene permiso */}
                        {tienePermiso('products_create') && (   
                            <div className="col-span-12 pt-6 flex justify-end">
                                <button
                                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 cursor-pointer"
                                    type="submit"
                                >
                                    Nueva categoría
                                    <span className="material-icons">save</span>
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};

export default New;